import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, Table, Form, FormInput } from '../../../../onestep-library/BaseUI/'
import PaymentSourceListing from './components/PaymentSourceListing'
import NewPaymentSourceForm from './components/NewPaymentSourceForm'
import { Elements } from 'react-stripe-elements'
import VerifyPaymentSource from './components/VerifyPaymentSourceForm'
import { fetchPaymentSources, submitUpdatePayerInfo } from './actions'

function PaymentSources(props){
  const dispatch = useDispatch();
  const { ui, payment_sources, errors, email, payer_name } = useSelector(state=>state.paymentSources)
  const organization = useSelector(state=>state.organization)
  const canCreatePaymentSource = React.useMemo(()=>( !!organization.payment_processor && (organization["ach_enabled?"] || organization["cc_enabled?"])),[organization])
  const { show, is_submitting } = ui
  const columnNames = organization["pay_simple?"] ? ['Payment Source', 'Type', ''] : ['Payment Source', 'Type', 'Status', ''];

  function onClose(){
    dispatch({type: 'UPDATE_PAYMENT_SOURCES_UI', payload: { show: false } })
    dispatch({type: 'CLEAR_PAYMENT_SOURCES_ERRORS' })
  }

  useEffect(()=>{ dispatch(fetchPaymentSources()) },[show])

  function handeAddPaymentSourceClick(){
    dispatch({type: 'CLEAR_PAYMENT_SOURCES_ERRORS' })
    dispatch({type: 'UPDATE_PAYMENT_SOURCES_UI', payload: { show: false } })
    dispatch({type: 'SET_NEW_PAYMENT_SOURCE_CALLBACK_ACTION', payload: { callback_action: 'UPDATE_PAYMENT_SOURCES_UI'}})
    dispatch({type: 'UPDATE_NEW_PAYMENT_SOURCE_FORM_UI', payload: { show: true } })
  }

  function onValidateRequiredFields() {
    return (
      !!email && email.length > 0 &&
      !!payer_name && payer_name.length > 0
    )
  }

  function onSubmit() {
    dispatch(submitUpdatePayerInfo())
  }

  return(
    <div>
      <Elements>
        <NewPaymentSourceForm/>
      </Elements>
      <VerifyPaymentSource/>
      <Modal
        className="w-100"
        title='Payment Info'
        show={show}
        size="lg"
        handleClose={onClose}
        headerButtons={ canCreatePaymentSource ? [{label: 'New Payment Source', handleClick: handeAddPaymentSourceClick}] : [] }>
        <Form
          isSubmitting={is_submitting}
          submitButtonLabel="Update Payment Info"
          errors={errors}
          handleClose={onClose} 
          handleValidateRequiredFields={onValidateRequiredFields}
          handleSubmit={onSubmit}>
          <FormInput
            label="Payer Name"
            value={payer_name}
            handleChange={(payer_name)=>dispatch({type:'UPDATE_PAYMENT_SOURCE_FIELD', payload: { payer_name } })}/>
          <FormInput
            label="Payer Email"
            value={email}
            desc="This email address is used when send email is enabled on invoices."
            handleChange={(email)=>dispatch({type:'UPDATE_PAYMENT_SOURCE_FIELD', payload: { email } })}/>
          <Table
            columnNames={columnNames}
            rows={payment_sources}
            Row={PaymentSourceListing}
            zeroCaseMessage="No Payment Sources"/>
          { payment_sources.filter(source=>!source.is_verified).length > 0 &&
            <div className="pt-1 pb-1">
              * Bank accounts must be verified before they are available for use.
            </div>
          }
          { false &&
            errors.length > 0 &&
            <div>
              <div className="font-weight-bold">The Following Error(s) occurred:</div>
              <ul className="pt-2">
                {errors.map((error, index) => (
                    <li key={index} className="text-danger">{error}</li>
                ))}
              </ul>
            </div>
          }
        </Form>
      </Modal>
    </div>
  )
}

export default PaymentSources
